import React, { useEffect } from "react";
import { History, Bell, Minus, Copy, Trash2, CopyPlus } from "lucide-react";

const fmtT = (epoch) => new Date(epoch * 1000).toLocaleString([], { hour12: false });

// Right-click menu on the chart. `target` = { x, y, candle, price, time, drawingId } in canvas coordinates.
export default function ChartContextMenu({ target, onClose, onReplayFrom, onAlertAt, onHLineAt, onCopyPrice, onDeleteDrawing, onDuplicateDrawing, decimals }) {
  useEffect(() => {
    if (!target) return;
    const close = () => onClose();
    window.addEventListener("mousedown", close);
    window.addEventListener("keydown", close);
    return () => { window.removeEventListener("mousedown", close); window.removeEventListener("keydown", close); };
  }, [target, onClose]);

  if (!target) return null;
  const items = [
    target.drawingId && { id: "dup-drawing", icon: CopyPlus, label: "Duplicate drawing", onClick: () => onDuplicateDrawing(target.drawingId) },
    target.drawingId && { id: "del-drawing", icon: Trash2, label: "Delete drawing", hint: "Del", onClick: () => onDeleteDrawing(target.drawingId) },
    target.candle && { id: "replay", icon: History, label: "Replay from here", hint: fmtT(target.candle.time), onClick: () => onReplayFrom(target.candle) },
    { id: "alert", icon: Bell, label: "Create alert at this price", hint: target.price.toFixed(decimals), onClick: () => onAlertAt(target.price) },
    { id: "hline", icon: Minus, label: "Horizontal line here", onClick: () => onHLineAt(target.price) },
    { id: "copy", icon: Copy, label: "Copy price", onClick: () => onCopyPrice(target.price) },
  ].filter(Boolean);

  return (
    <div data-testid="chart-context-menu" onMouseDown={(e) => e.stopPropagation()}
      className="absolute z-40 min-w-56 rounded-xl border border-border bg-popover shadow-xl p-1 text-sm animate-in fade-in zoom-in-95"
      style={{ left: Math.min(target.x, (target.maxX ?? 9999) - 240), top: target.y }}>
      {items.map((it) => (
        <React.Fragment key={it.id}>
          {(it.id === "alert" || it.id === "replay") && it.id !== items[0].id && <div className="my-1 h-px bg-border" />}
          <button data-testid={`ctx-${it.id}`} onClick={() => { it.onClick(); onClose(); }}
            className="w-full flex items-center gap-2 px-2.5 py-1.5 rounded-lg hover:bg-secondary text-left">
            <it.icon className="h-3.5 w-3.5 text-primary" />
            <span className="flex-1">{it.label}</span>
            {it.hint && <span className="text-[10px] text-muted-foreground font-mono-nums">{it.hint}</span>}
          </button>
        </React.Fragment>
      ))}
    </div>
  );
}
